// loads scripts that need to be on page - every entrypoint should import this!
import './kickstart';
import './ai2html';

import { createInteractiveMap } from './interactive-map';
import RaceBarChart from './RaceBarChart.svelte';

let raceData = [
  { race: 'White', vaccine: 42.8 },
  { race: 'Asian', vaccine: 39.4 },
  { race: 'Native American', vaccine: 31.7 },
  { race: 'Latino', vaccine: 29.3 },
  { race: 'Black', vaccine: 24.0 },
];
//{ race: 'Native American', vaccine: 923, pop: 73393 },

// Write your code!
async function main() {
  createInteractiveMap();

  new RaceBarChart({
    target: document.getElementById('vaccine-rate'),
    props: {
      data: raceData,
      width: document.getElementById('vaccine-rate').offsetWidth,
    },
  });
}

main().catch(console.error);
